import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../components/Header'

export default function Report() {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    type: 'email',
    title: '',
    description: '',
    scammerContact: '',
    companyName: '',
    additionalInfo: ''
  })
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      // TODO: Implement API call
      console.log('Submitting scam report:', formData)

      setTimeout(() => {
        setSuccess(true)
        setLoading(false)

        // Redirect after success
        setTimeout(() => {
          navigate('/dashboard')
        }, 3000)
      }, 1000)
    } catch (err) {
      setError('Failed to submit report. Please try again.')
      setLoading(false)
    }
  }

  if (success) {
    return (
      <div className="min-h-screen bg-[#0a0e17]">
        <Header />
        <div className="container mx-auto px-4 py-20 max-w-2xl">
          <div className="card text-center">
            <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-3xl font-bold text-white mb-2">Report Submitted!</h2>
            <p className="text-gray-400 mb-4">
              Thank you for helping protect the community from scams.
            </p>
            <p className="text-gray-500 text-sm mb-6">
              Our team will review your report and update our detection systems accordingly.
              You're being redirected to the dashboard...
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-[#0a0e17]">
      <Header />

      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-white mb-4" style={{ fontFamily: "'Orbitron', sans-serif" }}>
            Report a Scam
          </h1>
          <p className="text-gray-400 text-lg">
            Help protect others by reporting recruitment scams you've encountered.
            Your report will be reviewed and added to our detection database.
          </p>
        </div>

        <div className="card">
          {error && (
            <div className="bg-red-500/20 text-red-400 p-4 rounded-lg mb-6 border border-red-500/30">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Scam Type */}
            <div>
              <label className="block text-white font-semibold mb-2">Scam Type *</label>
              <select
                name="type"
                value={formData.type}
                onChange={handleChange}
                className="w-full bg-gray-900/50 border border-white/20 rounded-lg p-3 text-white focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none"
                required
              >
                <option value="email">Email Scam</option>
                <option value="linkedin">LinkedIn Message</option>
                <option value="text">Text Message</option>
                <option value="phone">Phone Call</option>
                <option value="other">Other</option>
              </select>
            </div>

            {/* Title */}
            <div>
              <label className="block text-white font-semibold mb-2">Report Title *</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Brief summary of the scam (e.g., 'Fake Google recruiter requesting payment')"
                className="w-full bg-gray-900/50 border border-white/20 rounded-lg p-3 text-white focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none"
                required
              />
            </div>

            {/* Description */}
            <div>
              <label className="block text-white font-semibold mb-2">Description *</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Describe what happened. Include specific red flags, tactics used, and how you identified it as a scam."
                rows={6}
                className="w-full bg-gray-900/50 border border-white/20 rounded-lg p-3 text-white focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none resize-none"
                required
              />
            </div>

            {/* Scammer Contact */}
            <div>
              <label className="block text-white font-semibold mb-2">Scammer Contact Info</label>
              <input
                type="text"
                name="scammerContact"
                value={formData.scammerContact}
                onChange={handleChange}
                placeholder="Email address, phone number, or LinkedIn profile"
                className="w-full bg-gray-900/50 border border-white/20 rounded-lg p-3 text-white focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none"
              />
              <p className="text-gray-500 text-sm mt-1">
                Help us identify and track the scammer
              </p>
            </div>

            {/* Company Name */}
            <div>
              <label className="block text-white font-semibold mb-2">Fake Company Name</label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Company name they claimed to represent"
                className="w-full bg-gray-900/50 border border-white/20 rounded-lg p-3 text-white focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none"
              />
            </div>

            {/* Additional Info */}
            <div>
              <label className="block text-white font-semibold mb-2">Additional Information</label>
              <textarea
                name="additionalInfo"
                value={formData.additionalInfo}
                onChange={handleChange}
                placeholder="Any other relevant details: domains used, payment methods requested, job titles mentioned, etc."
                rows={4}
                className="w-full bg-gray-900/50 border border-white/20 rounded-lg p-3 text-white focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none resize-none"
              />
            </div>

            {/* Privacy Notice */}
            <div className="bg-cyan-500/10 border border-cyan-500/30 rounded-lg p-4">
              <div className="flex items-start gap-3">
                <svg className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div>
                  <h4 className="text-cyan-400 font-semibold mb-1">Privacy Note</h4>
                  <p className="text-gray-400 text-sm">
                    Your report will be anonymized before being added to our database. Personal information will
                    not be shared publicly. We may contact you if we need clarification.
                  </p>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="flex gap-4">
              <button
                type="submit"
                disabled={loading}
                className="btn-primary flex-1 py-3 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Submitting...' : 'Submit Report'}
              </button>
              <button
                type="button"
                onClick={() => navigate('/dashboard')}
                className="px-6 py-3 border border-white/20 rounded-lg text-white hover:bg-white/5 transition"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
